import { render, staticRenderFns } from "./DefaultSelect.vue?vue&type=template&id=6963afe8"
import script from "./DefaultSelect.vue?vue&type=script&lang=js"
export * from "./DefaultSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports